module.exports = __webpack_public_path__ + "img/fraud-4.241f3af2.jpg";